module.exports = __webpack_public_path__ + "3872d70994056a718d5d7fa7bd37b7d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/signup/layouts/Footer/wechat-qr@2x.png
// module id = 1168
// module chunks = 0